import {
    BookOpen,
    Clock,
    HeartHandshake,
    Megaphone,
    School,
    Users,
} from "lucide-react";
import { ChecklistStrip } from "../GuideCards";

const implementationSettings = [
    "Classrooms — Advisory, SEL, Health",
    "After-school programs",
    "Counseling groups",
    "Peer leadership programs",
    "Anti-bullying campaigns",
    "School-wide initiatives",
];

const settingCards = [
    {
        title: "Classrooms",
        subtitle: "Advisory, SEL, Health",
        icon: BookOpen,
        color: "bg-[#16bdf4]",
    },
    {
        title: "After-school Programs",
        subtitle: "Programs and clubs",
        icon: Clock,
        color: "bg-[#ffbc00]",
    },
    {
        title: "Counseling Groups",
        subtitle: "Small group support",
        icon: HeartHandshake,
        color: "bg-[#ff5fa2]",
    },
    {
        title: "Peer Leadership Programs",
        subtitle: "Student-led impact",
        icon: Users,
        color: "bg-[#22c55e]",
    },
    {
        title: "Anti-bullying Campaigns",
        subtitle: "School culture initiatives",
        icon: Megaphone,
        color: "bg-[#ff6b35]",
    },
    {
        title: "School-wide Initiatives",
        subtitle: "Culture change",
        icon: School,
        color: "bg-[#a855f7]",
    },
];

export default function SchoolsImplementation() {
    return (
        <section
            id="bring-call-it-out"
            className="relative overflow-hidden bg-[#fff2cf] px-6 py-16 lg:px-8"
        >
            {/* Optional large background image placeholder */}
            <div
                className="absolute inset-0 bg-cover bg-center opacity-15"
                style={{
                    backgroundImage: "url('/assets/schools/implementation-bg.png')",
                }}
            />

            <div className="relative mx-auto max-w-6xl">
                <div className="mb-10 text-center">
                    <h2 className="text-4xl font-black uppercase leading-none md:text-5xl">
                        Flexible Implementation
                        <span className="block text-[#16bdf4] drop-shadow-[3px_3px_0_#000]">
                            For Schools
                        </span>
                    </h2>

                    <p className="mx-auto mt-4 max-w-2xl text-base font-bold leading-7 md:text-lg">
                        Across multiple settings, from classrooms to
                        school-wide initiatives.
                    </p>
                </div>

                <div className="mx-auto max-w-5xl">
                    <div className="mb-5 flex items-center justify-center gap-3 text-center">
                        <div className="flex h-11 w-11 items-center justify-center rounded-full border-[3px] border-black bg-[#ffbc00]">
                            <School size={22} strokeWidth={3} />
                        </div>

                        <h3 className="text-2xl font-black uppercase leading-tight md:text-3xl">
                            Use Call It Out For...
                        </h3>
                    </div>

                    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
                        {settingCards.map((setting) => {
                            const Icon = setting.icon;

                            return (
                                <section
                                    key={setting.title}
                                    className="
                                        flex items-center gap-4
                                        rounded-[18px] border-[3px] border-black bg-white p-4
                                        shadow-[5px_5px_0_#000]
                                    "
                                >
                                    <div
                                        className={`
                                            flex h-11 w-11 shrink-0 items-center justify-center
                                            rounded-full border-[3px] border-black ${setting.color}
                                        `}
                                    >
                                        <Icon size={22} strokeWidth={3} />
                                    </div>

                                    <div className="flex flex-col">
                                        <h3 className="text-base font-black uppercase leading-tight md:text-lg">
                                            {setting.title}
                                        </h3>

                                        {setting.subtitle && (
                                            <p className="mt-1 text-sm font-bold text-black/70">
                                                {setting.subtitle}
                                            </p>
                                        )}
                                    </div>
                                </section>
                            );
                        })}
                    </div>
                </div>

                <div className="mx-auto mt-9 max-w-4xl rounded-[24px] border-[5px] border-black bg-white p-6 text-center shadow-[8px_8px_0_#000]">
                    <p className="text-2xl font-black uppercase leading-tight">
                        Works for grades 6 – college.
                    </p>

                    <p className="mt-2 text-lg font-black uppercase text-[#ff3366]">
                        No prior training required.
                    </p>
                </div>
            </div>
        </section>
    );
}